<template>
  <div class="volumeMeasureBox" v-if="isShow">
    <div class="head">
      <span>{{title}}</span>
      <svg width="1em" height="1em" aria-hidden="true" fill="currentColor" @click="close">
        <use xlink:href="#icon-close-bold"></use>
      </svg>
    </div>
    <div class="main">
      <el-form :inline="true" :model="formInline" :rules="rules" ref="form" class="demo-form-inline">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="网格间距：" prop="gridSpacing">
              <el-select v-model="formInline.gridSpacing" placeholder="请选择" class="referenceAltitude-select" @change="disabledBtn = false">
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="基准高度：" prop="referenceAltitude">
              <el-input v-model.trim="formInline.referenceAltitude" placeholder="请输入" class="referenceAltitude-input"  @change="disabledBtn = false">
                <span slot="suffix">米</span>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="result" v-if="analyzeResult.length">
        <span class="title">计算结果</span>
<!--        <div>体积：<span>365975.023</span>立方米</div>-->
        <div>填方(立方米)</div>
        <div><span>{{analyzeResult[3].value}}</span></div>
        <div style="height: 5px"></div>
        <div>挖方(立方米)</div>
        <div><span>{{analyzeResult[2].value}}</span></div>
      </div>
    </div>
    <div class="bottom">
      <el-button @click="close" v-if="!analyzeResult.length">取消</el-button>
      <el-button @click="close" v-else>关闭</el-button>
      <el-button type="primary" @click="startCompute" v-if="!analyzeResult.length">计算</el-button>
      <el-button type="primary" @click="startCompute" v-else :disabled="disabledBtn">重新计算</el-button>
    </div>
    <div class="shade" v-if="showShade">
      <el-progress type="circle" :percentage="parseInt(progerss*100)" :stroke-width="10" color="rgba(0, 164, 240, 1)" stroke-linecap="round"></el-progress>
      <span class="text">计算中...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'volumeMeasureBox',
  props: {},
  components: {
  },
  data () {
    var validatePass = (rule, value, callback) => {
      // eslint-disable-next-line no-useless-escape
      const regu = /^(\-|\+)?\d+(\.\d+)?$/
      if (value === '') {
        callback(new Error('请输入基准高度'))
      } else {
        if (!regu.test(value)) {
          callback(new Error('请输入数值'))
        }
        callback()
      }
    }
    return {
      isShow: false,
      percentage: 50,
      title: '填挖方测量',
      showShade: false,
      showResult: false,
      contentStyle: {
        height: 'auto'
      },
      options: [{
        value: '5',
        label: '5米'
      }, {
        value: '2',
        label: '2米'
      }, {
        value: '10',
        label: '10米'
      }],
      formInline: {
        gridSpacing: '5',
        referenceAltitude: ''
      },
      rules: {
        gridSpacing: [
          { required: true, message: '请输入网格间距', trigger: 'change' }
        ],
        referenceAltitude: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ]
      },
      isAnalyzing: false,
      // 标注id
      marekerId: undefined,
      // 分析结果
      analyzeResult: [],
      // 分析进度
      progerss: 0,
      disabledBtn: true
    }
  },
  computed: {
    name () {
      return this.data
    }
  },
  watch: {
    data (newValue, oldValue) {

    }
  },
  methods: {
    async open (marker) {
      this.$nextTick(() => {
        this.$store.dispatch('setDrawState', true)
        this.formInline.gridSpacing = '5'
      })
      this.marekerId = marker.id
      const polygoneGis = marker.getPolygonGisPositions()
      const res = await this.$cesiumPlus.utils.samplePointHeight(this.$cesiumPlus.viewer, polygoneGis[0][0], polygoneGis[0][1])
      this.formInline.referenceAltitude = parseFloat(res.toFixed(8))
      this.isShow = true
    },
    close () {
      this.isShow = false
      this.isAnalyzing = false
      this.analyzeResult = []
      this.showShade = false
      this.progerss = 0
      this.cancelAnalyze()
      this.$cesiumPlus.volumeMeasure.clear()
      this.$store.commit('showVolumeMeasureBox', null)
      this.$store.dispatch('setDrawState', false)
    },
    // 开始计算
    startCompute () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isAnalyzing = true
          this.showShade = true
          this.progerss = 0
          this.analyzeResult = []
          const marker = this.$cesiumPlus.markerManager.getMarkerById(this.marekerId)
          if (!marker) {
            this.$message.error('请先勾绘分析的区域')
            return
          }
          this.$cesiumPlus.volumeMeasure.analyze({
            marker: marker,
            debug: false,
            sampleSpace: this.formInline.gridSpacing,
            depth: this.formInline.referenceAltitude,
            onStart: this.staretAnalyze.bind(this),
            onProgerssing: this.updateProgerssing.bind(this),
            onFinish: this.analyzeFinish.bind(this)
          })
          // eslint-disable-next-line no-undef
          // cesiumViewer.scene.preRender.addEventListener(this.analyzeTimer, this)
        } else {
        }
      })
    },
    // 开始分析回调
    staretAnalyze () {
      this.isAnalyzing = true
      this.lastSampleTime = Cesium.JulianDate.now()
    },
    // 更新进度
    updateProgerssing (progerss) {
      this.progerss = progerss
      this.lastSampleTime = Cesium.JulianDate.now()
      // this.isAnalyzing = true
    },
    // 分析完成
    analyzeFinish (result) {
      this.analyzeResult = []
      this.analyzeResult.push({
        name: '采样间距：',
        value: this.formInline.gridSpacing + 'm'
      })
      this.analyzeResult.push({
        name: '基准面高度：',
        value: this.formInline.referenceAltitude + 'm'
      })
      this.analyzeResult.push({
        name: '挖方：',
        value: result.excavation.toFixed(8)
      })
      this.analyzeResult.push({
        name: '填方：',
        value: result.fill.toFixed(8)
      })
      this.progerss = 1
      this.isAnalyzing = false
      this.showShade = false
      this.disabledBtn = true
    },
    // 分析计数
    analyzeTimer (scene, time) {
      let overTime = 0
      if (this.lastSampleTime) {
        overTime = Cesium.JulianDate.compare(Cesium.JulianDate.now(), this.lastSampleTime)
      }
      // 超时
      if (overTime > 5) {
        this.cancelAnalyze()
        this.$message.error('模型缺失，分析失败！')
      }
    },
    // 取消分析
    cancelAnalyze () {
      this.$cesiumPlus.volumeMeasure.stopAnalyze()
      this.isAnalyzing = false
      this.lastSampleTime = undefined
      this.$cesiumPlus.markerManager.removeMarkerById(this.marekerId)
      // eslint-disable-next-line no-undef
      // cesiumViewer.scene.preRender.removeEventListener(this.analyzeTimer, this)
    }
  },
  filters: {}
}
</script>
<style lang="scss">
.volumeMeasureBox{
  width: 340px;
  min-height: 280px;
  height: auto;
  background: rgba(36, 37, 38, 0.95);
  border: 1px solid #565759;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 50%;
  margin-left: -170px;
  margin-top: -140px;
  overflow: hidden;
  .head{
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #FFFFFF;
    border-bottom: 1px solid #464748;
    >svg{
      transform: scale(1.2);
    }
  }
  .main{
    padding: 20px;
    box-sizing: border-box;
    .el-form-item__label{
      color: #BBBBBB;
      padding-right: 0;
    }
    .referenceAltitude-input{
      width: 195px;
      .el-input-group__append{
        height: 32px;
        >span{
          color: #999999;
        }
      }
      .el-input__suffix{
        width: 32px;
        height: 32px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 0px 6px 6px 0px;
        transform: translate(5px, 4px);
        .el-input__suffix-inner{
          transform: translateX(8px);
        }
      }
    }
    .referenceAltitude-select{
      width: 195px;
    }
  }
  .bottom{
    width: 100%;
    height: 48px;
    background: rgba(255, 255, 255, 0.05);
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: end;
    padding-right: 10px;
    >button{
      width: 80px;
    }
  }
  .shade{
    width: 340px;
    height: 232px;
    background: rgba(36, 37, 38, 0.95);
    border-radius: 0px 0px 12px 12px;
    position: absolute;
    top: 48px;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    .text{
      position: absolute;
      bottom: 60px;
    }
    .el-progress-circle{
      width: 90px !important;
      height: 90px !important;
      transform: translateY(-40px);
      svg{
        path:first-child {
          stroke: #666666;
        }
      }
    }
    .el-progress__text{
      transform: translateY(-45px);
      color: #ffffff;
      font-size: 14px;
    }
  }
  .result{
    width: 265px;
    height: 116px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    margin: 0 auto;
    margin-bottom: 50px;
    position: relative;
    padding-top: 15px;
    box-sizing: border-box;
    margin-top: 10px;
    .title{
      position: absolute;
      display: inline-block;
      font-size: 12px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #BBBBBB;
      background: rgb(43, 44, 45,0.9);
      width: 80px;
      top: -10px;
      left: 50%;
      margin-left: -40px;
      text-align: center;
      border-radius: 4px;
    }
    >div{
      font-size: 12px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #999999;
      display: flex;
      align-items: center;
      padding-left: 20px;
      >span{
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #FFFFFF;
        margin-right: 5px;
      }
    }
  }
}
</style>
